//button click to scroll
document.querySelectorAll("button[data-target]").forEach(btn => {
    const color = btn.getAttribute("data-color");
    
    // The Hex Trick: Appends '80' to make the background fill exactly 50% transparent
    const hoverFillColor = color + "80"; 

    btn.addEventListener("mouseenter", () => {
        // Only apply the hover fill if the button is NOT the active section
        if (!btn.classList.contains("active")) {
            btn.style.backgroundColor = hoverFillColor;
        }
    });

    btn.addEventListener("mouseleave", () => {
        // When the mouse leaves, return it to the empty state (if it isn't active)
        if (!btn.classList.contains("active")) {
            btn.style.backgroundColor = "transparent";
        }
    });
    btn.addEventListener("click", () => {
        const targetId = btn.getAttribute("data-target");
        const target = document.getElementById(targetId);

        if (target) {
            console.log(`clicked ${btn.id}`);

            const newIndex = sections.findIndex(sec => sec.id === targetId);
            if (newIndex !== -1) {
                window.currentIndex = newIndex;
            }

            if (window.lenis) {
                window.lenis.scrollTo(target, { offset: 0, duration: 1.2 });
            }
        }
    });
});

// Map section IDs to their labels (as per your nav buttons)
const sectionLabels = {
    startPg: "Welcome.",
    employabilityPg: "My Youth.",
    designPg: "My Time Studying.",
    stylePg: "My Technical Skills.",
    passionPg: "Today and Tomorrow.",
    hobbyPg: "Passions and Interests.",
    contactPg: "Reach out."
};

//active colour code

// const sections = Object.keys(sectionLabels).map(id => document.getElementById(id));

const buttons = document.querySelectorAll("button[data-target]");

//this is the hover to change the text in the navTitle

let currentSectionLabel = "Welcome"; // Default
// 1. Target the text display
const navTitle = document.getElementById("navTitle");

// 2. The Active Observer
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        // Triggers when a section crosses the middle of the screen
        if (entry.isIntersecting) {
            const currentId = entry.target.id;
            const newLabel = sectionLabels[currentId];

            if (newLabel) {
                // A. Update the global variable so your hover effects don't break it
                currentSectionLabel = newLabel;
                

                // B. Update the actual text on the screen (Top Right Display)
                if (navTitle) {
                    navTitle.innerText = currentSectionLabel;
                }

                // C. Highlight the active tab in the Top Nav Bar
                document.querySelectorAll("button[data-target]").forEach(btn => {
                    const color = btn.getAttribute("data-color");

                    
                    if (btn.getAttribute("data-target") === currentId) {
                        // Active State (I am pulling your exact data-color attribute for a clean underline!)
                        btn.classList.add("active");
                        btn.style.backgroundColor = color;
                        
                    } else {
                        // Inactive State
                        btn.classList.remove("active");
                        btn.style.backgroundColor = "transparent";
                    }
                });
            }
        }
    });
}, { threshold: 0.5 }); // 50% of the section must be visible

// 3. Connect the observer safely to your sections
const sectionsToObserve = Object.keys(sectionLabels).map(id => document.getElementById(id));

sectionsToObserve.forEach(section => {
    if (section !== null) {
        observer.observe(section);
    }
});

// const observer = new IntersectionObserver(
//     entries => {
//         // Find the entry that is most visible
//         let mostVisible = null;
//         let maxRatio = 0;
//         entries.forEach(entry => {
//             if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
//                 mostVisible = entry;
//                 maxRatio = entry.intersectionRatio;
//                 console.log("observed")
//             }
//         });

//         if (mostVisible) {
//             // Set active button
//             buttons.forEach(btn => btn.classList.remove("active"));
//             const activeBtn = document.querySelector(
//                 `button[data-target="${mostVisible.target.id}"]`
//             );
//             if (activeBtn) {
//                 activeBtn.classList.add("active");
//             }

//             // Update navTitle and currentSectionLabel
//             const label = sectionLabels[mostVisible.target.id];
//             navTitle.textContent = label;
//             currentSectionLabel = label;
//         }
//     },
//     { threshold: 0.8 } // Adjust as needed
// );

// 1. The Robust Observer
// const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//         // If the section crosses the 50% threshold of the screen
//         if (entry.isIntersecting) {
//             const currentId = entry.target.id;
            
//             // Look up the correct text label using the exact ID
//             const newLabel = sectionLabels[currentId];
            
//             if (newLabel) {
//                 // Update your global index (if you still need it)
//                 window.currentIndex = Object.keys(sectionLabels).indexOf(currentId);
                
//                 // --- PUT YOUR NAVBAR TEXT UPDATE LOGIC HERE ---
//                 // Example: document.getElementById('navTitle').innerText = newLabel;
//                 console.log(`Active Section: ${newLabel}`); 
//             }
//         }
//     });
// }, { 
//     // IMPORTANT: It only triggers when 50% of the section is visible
//     threshold: 0.5 
// });

// 2. The Safe Loop
const sections = Object.keys(sectionLabels).map(id => document.getElementById(id));

sections.forEach(section => {
    if (section !== null) {
        observer.observe(section);
    } else {
        // This will tell you EXACTLY which ID is missing in your index.html!
        console.warn(`WARNING: Observer could not find an HTML section with the ID!`);
    }
});

// Observe each section
// sections.forEach(section => {
//     if (section) observer.observe(section);
// });



document.querySelectorAll("button[data-target]").forEach(btn => {
    btn.addEventListener("mouseenter", () => {
        navTitle.textContent = btn.getAttribute("data-label");
    });
    //add event listener for mouse leave to reset to most visible section
    btn.addEventListener("mouseleave", () => {
        navTitle.textContent = currentSectionLabel;
    });
});

document.querySelectorAll("button[data-target]").forEach(btn => {
    const color = btn.getAttribute("data-color");
    if (color) {
        btn.style.setProperty("--btn-color", color); // assign custom property
    }
});

// sections.forEach(section => observer.observe(section));

// sections.forEach(section => {
//     if (section !== null) {
//         observer.observe(section);
//     }
// });

/**
 * clock for navbar
 */

setInterval(showTime, 1000);

export function showTime() {
    let time = new Date()
    let options = { timeZone: 'Australia/Brisbane', hour: '2-digit', minute: '2-digit', second: '2-digit' };
    let eastCoastTime = time.toLocaleString('en-UK', options);

    document.getElementById("clock").innerHTML = eastCoastTime

}
//get temperature using this tut https://www.youtube.com/watch?v=VaDUGPMjzOM
export async function showTemp() {

    //set variables
    //brisbane long and lat
    const latitude = -27.470125
    const longitude = 153.021072
    //apikeys
    const apiKey = '893aa7f7ee5f4afa2faa50c5c1aab7ff'
    const apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}`

    //check if api responds
    const response = await fetch(apiUrl)

    //makes weatherdata a readable format from api
    const weatherData = await response.json()

    //console.log(weatherData)

    //depreicates api content to make it so it only gets the temperature from the object
    const { main: { temp } } = weatherData
    console.log(temp - 273.15)

    //replace element ID convers kelvin to celcius
    document.getElementById("tempDisplay").innerHTML = Math.round(temp - 273.15) + 'º'
}